import { useCallback, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { getParamTable, getParamTempTableFiltering, _setAxios } from 'lib/Helper';

const initialTableState = () => ({
    loading_first: false,
    loading: false,
    data: [],
    search: "",
    pagination: {
        current: 1,
        pageSize: 10,
        total: null,
    },
    sorting: [],
    filtering: {
    },
    flagRed: "nilai_status_terkirim",
    flagRedValue: "0"
});

const useList = (privilege, match) => {
    const { access } = privilege
    const { action } = access["/penilaian/status-nilai"] || {}

    const [headerData, setHeaderData] = useState([])
    const [table, setTable] = useState({
        ...initialTableState(),
        filtering: {
            ...initialTableState().filtering,
        },
    });
    const [filterState, setFilterState] = useState({
        values: {
            ...table.filtering
        }, visible: false
    });

    const fetchData = useCallback(async (params = {}, isNew = false) => {
        updateTableLoadingState(isNew);
        params.pagination.current = isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current;

        const resp = await _setAxios("penilaian/mapel/status/detail/table", "POST", params);
        if (resp.status) {
            setTimeout(() => {
                updateTableData(resp.data, params, isNew);
            }, 0);
        } else {
            resetTableLoadingState();
        }
    }, []);

    const fetchTable = useCallback((isNew = false, paramsCustom = null) => {
        const params = getParamTable("default", table);
        fetchData(paramsCustom || params, isNew);
    }, [table, fetchData]);

    const updateTableLoadingState = (isNew) => {
        setTable(prev => ({
            ...prev,
            loading_first: isMobile ? isNew : false,
            loading: true
        }));
    };

    const resetTableLoadingState = () => {
        setTable(prev => ({ ...prev, loading_first: false, loading: false }));
    };

    const updateTableData = (data, params, isNew) => {
        const updatedData = isNew ? [] : params.data;
        const current = params.pagination.current
        const newCurrent = isMobile ? current + 1 : current;

        setTable(prev => ({
            ...prev,
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...updatedData, ...data?.list] : data?.list,
            pagination: {
                ...prev.pagination,
                current: newCurrent,
                total: data.info.total,
            },
        }));
    };

    const setTempTableFilter = (name, value) => {
        setFilterState(prev => ({
            ...prev,
            values: { ...prev.values, [name]: value }
        }));
        setTable(prev => ({ ...prev, filtering: { ...prev.filtering, [name]: value } }));
    };

    const setTableFilterFromTemp = () => {
        const params = getParamTempTableFiltering(table, filterState.values);
        fetchData(params, isMobile);
    };

    const getHeader = useCallback(async (rombelId) => {
        const resp = await _setAxios("penilaian/mapel/status/detail/" + rombelId, "GET");
        if (resp.status) {
            const data = resp?.data?.data;
            const params = getParamTempTableFiltering(table, {
                tahun_ajaran_id: data?.tahun_ajaran_id,
                semester_id: data?.semester_id,
                rombel_id: rombelId,
            });
            setHeaderData(data || []);

            const isNew = isMobile ? true : false;
            fetchTable(isNew, params);
            setTable(prev => ({
                ...prev, filtering: {
                    ...prev.filtering,
                    tahun_ajaran_id: data?.tahun_ajaran_id,
                    semester_id: data?.semester_id,
                    rombel_id: rombelId,
                }
            }));
        }
    }, [fetchTable, table]);

    useEffect(() => {
        getHeader(match.params.id)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id])

    return {
        action,
        headerData,
        table,
        filterState,
        fetchTable,
        fetchData,
        setTempTableFilter,
        setTableFilterFromTemp,
    };
};

export default useList;
